import * as yup from 'yup'
import { VALIDATION } from 'utils/globalConstant'

export const validationSchema = yup.object({
  department_name: yup
  .string()
  .required(VALIDATION.required)
  .max(150, VALIDATION.max),
})
